import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import { AppError } from '../../../framework/models/errors';
import AttachedFiles from '../../components/AttachedFiles';
import { AutoResizeTextarea } from '../../components/AutoResizeTextarea';
import StyledBox from '../../components/StyledBox';
import { useGetNotice } from '../../hooks/queries/notice';
import useToastHook from '../../hooks/ToastHook';
import { FileKind } from '../../models/gen/fileKind';
import { NoticeGetResult } from '../../models/gen/noticeGetResult';
import { Formatter } from '../../utils/FormatUtils';
import { useSizeContext } from '../SizeProvider';

type NotificationState = {
  isOpen?: boolean;
  noticeId?: number;
  data?: NoticeGetResult;
  onClose: Runnable;
};

/**
 * お知らせ詳細ダイアログ
 *
 * @returns
 */
export const NotificationDetailModal: React.FunctionComponent<
  NotificationState
> = ({ isOpen, noticeId, onClose }) => {
  const sizes = useSizeContext();

  const { data, error, isError, isLoading, remove } = useGetNotice({
    id: noticeId,
  });

  React.useEffect(() => {
    if (!isOpen) remove();
  }, [isOpen]);

  const { toast } = useToastHook();
  React.useEffect(() => {
    if (isError) {
      toast(error instanceof AppError ? error : 'お知らせの取得に失敗しました');
    }
  }, [isError]);

  return (
    <Modal isOpen={!!isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <Skeleton isLoaded={!isLoading}>
          <ModalHeader fontSize={sizes.fontSize.modalHeader}>
            {data?.result?.subject}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            alignItems="start"
            as={VStack}
            fontSize={sizes.fontSize.modalBody}
            paddingBottom="24px"
          >
            <Text>
              表示期間: {Formatter.date(data?.result?.dateFrom, false, '―')}～
              {Formatter.date(data?.result?.dateTo, false, '―')}
            </Text>
            <StyledBox
              width="full"
              as={AutoResizeTextarea}
              maxHeight={'40vh'}
              style={{ overflow: 'auto' }}
            >
              {data?.result?.body}
            </StyledBox>
            <AttachedFiles
              fileKind={FileKind.Notice}
              files={data?.result?.attachedFiles}
            />
          </ModalBody>
        </Skeleton>
      </ModalContent>
    </Modal>
  );
};
